import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { Icon } from '@st-operations/uikit/src/v2/index.js'
import Form from '_components/form/Form'
import IconACSizes from '../../IconSizes'

import { useCollapsibleElement } from '_hooks'

import './styles.scss'

const DestinationCard = ({
  destinations,
  fields,
  schema,
  item,
  disabled,
  onChange,
  getSize,
  handleRemove,
}) => {
  const { isOpen, collapsibleHeight, collapsibleRef, TriggerCollapsible } = useCollapsibleElement(
    [],
    true
  )
  return (
    <section className="destinations-card">
      <header className="destinations-card__header-container">
        <div className="destinations-card__header">
          <For each="destination" index="index" of={destinations}>
            <p key={index} className="destinations-card__title">
              <span className="destinations-card__size">
                <IconACSizes /> {getSize(destination)}
              </span>
              <div className="destinations-card__name-id">
                <span className="destinations-card__name">{destination.name}</span>
                <If condition={destination.externalId}>
                  <span className="destinations-card__id">ID {destination.externalId}</span>
                </If>
              </div>
              <button
                className="destinations-card__delete"
                title="Remove destination"
                onClick={() => disabled || handleRemove(destination)}
              >
                <Icon icon="trashcan" type="outline" width={22} height={22} color="#3D3D3D" />
              </button>
            </p>
          </For>
        </div>
        <If condition={fields}>
          <TriggerCollapsible />
        </If>
      </header>
      <div
        style={{ maxHeight: collapsibleHeight }}
        ref={collapsibleRef}
        className={classnames('destinations-card__content', {
          'destinations-card__content--open': fields && isOpen,
        })}
        aria-hidden={!fields || !isOpen}
      >
        <If condition={fields}>
          <Form
            fields={fields
              .filter((name) => fields.includes(name))
              .map((name) => ({
                name,
                className: 'selected-destinations__field',
              }))}
            schema={schema}
            ordered={['appnexusPricingCategoryId', 'ttdContextualPriceId']}
            item={item}
            onChange={onChange}
            className="selected-destinations__form"
            disabled={disabled}
          />
        </If>
      </div>
    </section>
  )
}

DestinationCard.propTypes = {
  destinations: PropTypes.array,
  fields: PropTypes.array,
  schema: PropTypes.shape(),
  item: PropTypes.shape(),
  onChange: PropTypes.func,
}

DestinationCard.defaultProps = {
  destinations: [],
  fields: null,
  schema: {},
  item: {},
  onChange: () => {},
}

export default DestinationCard
